import React from 'react';

export function ClientInvoices() {
  return (
    <div style={{ padding: '2rem' }}>
      <h1 style={{ fontSize: '2rem', fontWeight: '500', margin: '0 0 2rem 0' }}>My Invoices</h1>
      <div style={{ 
        background: 'white', 
        border: '1px solid #e5e7eb', 
        borderRadius: '0.75rem', 
        padding: '2rem',
        textAlign: 'center',
        color: '#6b7280'
      }}>
        <h3>Invoice History</h3>
        <p>This page will display the client's invoice history with payment options.</p>
      </div>
    </div>
  );
}
